import React from 'react'
import { IVersionUpdateData } from '../MasterIdSelection'
import { Box, Button } from '@mui/material'
import { useLatestProductVersion } from '../../../utility/TreeHelpers'
import { IMasterCurricula } from 'infrastructure/api'
import { DateComponent, TreeEditInfo } from '../../TreeEditInfo'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { selectedUpdatesAtom } from './atoms'
import { useUpdatesActions } from './utility'
import { TreeValidations } from './TreeValidations'
import { goToMasterUpdateValidation } from 'app/Routers'
import { hasMasterUpdateValidationErrors } from '../../../masters_management/utility'

export function MasterUpdate({
  disabled,
  excuse,
  require,
  bypassValidations,
  index,
}: {
  disabled: boolean
  excuse: () => void
  require: () => void
  bypassValidations: boolean
  index: number
}) {
  const update = useAtomValue(selectedUpdatesAtom)[index]
  const { removeUpdateAtIndex, refreshAtIndex } = useUpdatesActions()
  const getLatestVersion = useLatestProductVersion()

  return (
    <Box
      flexDirection="row"
      display="flex"
      justifyContent="space-between"
      style={{ padding: 12, border: 'solid 1px lightGrey' }}
    >
      <VersionUpdateDisplay
        updateData={update}
        master={getLatestVersion(update.productId)}
      />
      {!disabled && (
        <Box display="flex" flexDirection="column">
          <Button
            disabled={disabled}
            onClick={() => removeUpdateAtIndex(index)}
          >
            Remove
          </Button>
          <Button onClick={() => refreshAtIndex(index)}>Refresh</Button>
          {!bypassValidations && (
            <Button disabled={disabled} onClick={excuse}>
              SkipValidate
            </Button>
          )}
          {bypassValidations && (
            <Button disabled={disabled} onClick={require}>
              Validate
            </Button>
          )}
        </Box>
      )}
    </Box>
  )
}

function VersionUpdateDisplay({
  updateData,
  master,
}: {
  updateData: IVersionUpdateData
  master?: IMasterCurricula
}) {
  const border =
    updateData.fromTreeTitle !== updateData.toTreeTitle
      ? 'solid 1px orange'
      : ''
  return (
    <Box border={border} padding="12px">
      <Box>
        <Box>
          <b>{updateData.toTreeTitle}</b> version <b>{master?.name}</b>
        </Box>
        <Box>{`${master?.treeId}:${master?.version}`}</Box>
        <Box width={200}>
          <DateComponent title={'Created'} date={master?.createdAt} />
        </Box>
        <Box>
          Updating to <b>{updateData.newVersionName}</b>{' '}
          {updateData.newTree.title}
        </Box>
        {!updateData.fromTreeTitle?.includes(updateData.toTreeTitle) && (
          <Box>
            Titles do not match, please check this is correct, from tree:
            <b>{updateData.fromTreeTitle}</b>
          </Box>
        )}
      </Box>
      <Box>{`${updateData.newTree.tree_id}:${updateData.newTree.version}`}</Box>
      <TreeEditInfo
        treeId={updateData.newTree.tree_id}
        versionId={updateData.newTree.version}
      />
      <UpdateValidations updateData={updateData} />
    </Box>
  )
}

function UpdateValidations({ updateData }: { updateData: IVersionUpdateData }) {
  const { validations } = updateData
  if (!hasMasterUpdateValidationErrors(validations)) return null
  return (
    <Box>
      <Box color="#cc0000">
        Updating to a tree that has issues that must be resolved first
      </Box>
      <Box padding="5px">
        <TreeValidations validations={validations} />
      </Box>
      <Button onClick={() => goToMasterUpdateValidation(updateData)}>
        Go To Validation
      </Button>
    </Box>
  )
}
